import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_filing_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  type_1: fromDatatype.VarcharDatatypeInterface;
  type_2: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface
  revision_num: fromDatatype.IntegerDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  date_filing: fromDatatype.TimestampTzDatatypeInterface;
  amount_start_debit: fromDatatype.NumericDatatypeInterface;
  amount_start_credit: fromDatatype.NumericDatatypeInterface;
  amount_net_debit: fromDatatype.NumericDatatypeInterface;
  amount_net_credit: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  filing_type: fromDatatype.VarcharDatatypeInterface;
  filing_code: fromDatatype.VarcharDatatypeInterface;
  filing_option: fromDatatype.TextDatatypeInterface;
  filing_namespace: fromDatatype.NamespaceDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  locked_status: fromDatatype.VarcharDatatypeInterface;
  locked_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  locked_time: fromDatatype.TimestampTzDatatypeInterface;
  filing_year_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_filing_hdr_RowClass
  implements bl_fi_filing_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  type_1: fromDatatype.VarcharDatatypeInterface;
  type_2: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  revision_num: fromDatatype.IntegerDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  date_filing: fromDatatype.TimestampTzDatatypeInterface;
  amount_start_debit: fromDatatype.NumericDatatypeInterface;
  amount_start_credit: fromDatatype.NumericDatatypeInterface;
  amount_net_debit: fromDatatype.NumericDatatypeInterface;
  amount_net_credit: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  filing_type: fromDatatype.VarcharDatatypeInterface;
  filing_code: fromDatatype.VarcharDatatypeInterface;
  filing_option: fromDatatype.TextDatatypeInterface;
  filing_namespace: fromDatatype.NamespaceDataFieldInterface;
  doc_line_guid: fromDatatype.GuidDataFieldInterface;
  locked_status: fromDatatype.VarcharDatatypeInterface;
  locked_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  locked_time: fromDatatype.TimestampTzDatatypeInterface;
  filing_year_guid: fromDatatype.GuidDataFieldInterface;
}
